<div class="{{ announcement.cssClass ? announcement.cssClass : '' }}"
     [ngClass]="{ 'announcement-background-color-wrapper': !announcement.alignBottom }">
    <div class="width-restrictor width-restrictor--responsive">
        <div class="announcement-section"
             *ngIf="showAnnouncement"
             [ngClass]="{ 'announcement-section--bottom': announcement.alignBottom }">
            <div *ngIf="announcement.iconClass"
                 class="{{ cssClassFont + ' announcement-section__icon-container' }}">
                <span class="announcement-section__icon {{ announcement.iconClass }}"></span>
            </div>
            <div class="announcement-section__container"
                 [ngClass]="{ 'announcement-section__container--bottom': announcement.alignBottom }">
                <h2 *ngIf="!announcement.alignBottom && !announcement.titleUseSubtitleStyle"
                    class="{{ cssClassFont + ' announcement-section__title bold' }}"
                    aria-labelledby="this.announcementId">
                    <span [id]="this.announcementId">{{ announcement.title }}</span>&nbsp;
                    <a class="announcement-suggestion-link ms-fcl-tp ms-fcl-tp-h ms-fcl-tdr-f ms-fcl-tdr-a"
                       id="{{ 'announcement-suggestion-link_' + announcement.index }}"
                       *ngIf="announcement.titleRedirectionSuggestion"
                       [href]="announcement.titleRedirectionSuggestion.url">
                        {{ announcement.titleRedirectionSuggestion.text }}</a>
                </h2>
                <div *ngIf="announcement.alignBottom"
                     class="{{ cssClassFont + ' announcement-section__title' }}">{{ announcement.title }}</div>
                <div *ngIf="announcement.titleUseSubtitleStyle"
                     class="{{ cssClassFont + ' announcement-section__label' }}"
                     [innerHTML]="announcement.title"></div>
                <div *ngIf="announcement.subTitle"
                     class="{{ cssClassFont + ' announcement-section__label' }}"
                     [innerHTML]="announcement.subTitle"></div>
            </div>
            <div *ngIf="announcement.primaryButton || announcement.secondaryButton || announcement.borderlessButton"
                 class="announcement-section__actions buttons-container"
                 [ngClass]="{ 'announcement-section__actions--bottom': announcement.alignBottom }">
                <button *ngIf="announcement.primaryButton"
                        [id]="announcement.primaryButton.id"
                        [attr.data-area]="componentArea"
                        [attr.aria-label]="announcement.primaryButton.ariaLabel"
                        class="generic-button generic-button--fluent"
                        [ngClass]="{
                                'ms-bgc-tp ms-fcl-w': !announcement.alignBottom,
                                'generic-button--fluent--primary ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a': !announcement.alignBottom,
                                'callout-button callout-button--themed-primary ms-bgc-w ms-fcl-tp ms-bgc-tlr-h ms-bcl-tp-h ms-bgc-tl-a ms-fcl-tp-f': announcement.alignBottom
                            }"
                        (click)="announcement.primaryButton.onClick()">
                    <span class="generic-button__text">{{ announcement.primaryButton.text }}</span>
                </button>
                <button *ngIf="announcement.secondaryButton"
                        [id]="announcement.secondaryButton.id"
                        [attr.data-area]="componentArea"
                        [attr.aria-label]="announcement.secondaryButton.ariaLabel"
                        class="generic-button generic-button--fluent generic-button--fluent--secondary ms-bgc-w ms-bgc-tp-h ms-bgc-tp-a ms-fcl-tp ms-fcl-w-h ms-fcl-w-a"
                        (click)="announcement.secondaryButton.onClick()">
                    <span class="generic-button__text">{{ announcement.secondaryButton.text }}</span>
                </button>
                <button *ngIf="announcement.borderlessButton"
                        [id]="announcement.borderlessButton.id"
                        [attr.data-area]="componentArea"
                        [attr.aria-label]="announcement.borderlessButton.ariaLabel"
                        class="generic-button announcement-section__borderless-button"
                        (click)="announcement.borderlessButton.onClick()">
                    <span class="generic-button__text announcement-section__borderless-button__text">{{ announcement.borderlessButton.text }}</span>
                </button>
            </div>
            <div *ngIf="!(announcement.primaryButton || announcement.secondaryButton) || announcement.alignBottom || announcement.dismissible"
                 class="announcement-close__container"
                 [ngClass]="{ 'announcement-close__container--bottom': announcement.alignBottom }">
                <button id="close-announcement"
                        [attr.data-area]="componentArea"
                        class="{{ cssClassFont + ' announcement-close__button' }}"
                        (click)="onDismissClick()"
                        [attr.aria-label]="dismissAriaLabel">
                    <ohp-icon-font iconFontName="X2"
                                   size="14"
                                   cssClass="announcement-close__icon"></ohp-icon-font>
                </button>
            </div>
        </div>
    </div>
</div>
